@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.StackButton {
  display: inline-flex;
  color: transparent;
  padding: 6px;
  cursor: pointer;
  background: $theme-color-background;
  width: 18px;
  height: 18px;
  justify-content: center;
  align-items: center;
  border: 1px solid $theme-color-divider;

    svg {
      display: absolute;
    }

  &:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  &:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  &:only-child {
    border-radius: 4px;
  }
  
  // overlap sibling boxes by 1px to give the visual of only 1px divider between boxes
  + #{&} {
    margin-left: -1px;
  }

  &:hover {
    background: $theme-color-secondary-button-hover;
  }
}